// extracted by mini-css-extract-plugin
export default {"base":"step-card-module__base--Wzz","number":"step-card-module__number--pu0"};